import { _CopywritingBase } from './copywritingBase'

export class _CopywritingDefault extends _CopywritingBase {
  cssType: 'default' | 'small' = 'default'
  protected initPC(): this {
    this['--copywriting-gap'] = '0.08rem'
    this['--headline-font-size'] = '0.2rem'
    this['--logo-width'] = '0.38rem'
    this['--logo-height'] = '0.38rem'
    this['--name-font-size'] = '0.2rem'
    this['--description-font-size'] = '0.16rem'
    return this
  }
  protected initH5(): this {
    this['--copywriting-gap'] = '0.12rem'
    this['--headline-font-size'] = '0.26rem'
    this['--logo-width'] = '0.7rem'
    this['--logo-height'] = '0.7rem'
    this['--name-font-size'] = '0.32rem'
    this['--description-font-size'] = '0.24rem'
    return this
  }
}
